var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9657 1.80774C27.396 0.478718 28.1031 0.478718 28.5362 1.80774L33.623 17.467C34.056 18.7946 35.5525 19.8825 36.9489 19.8825H53.4166C54.813 19.8825 55.0323 20.5539 53.9017 21.3746L40.5804 31.0532C39.4484 31.8739 38.877 33.6331 39.31 34.9608L44.3982 50.62C44.8299 51.949 44.2584 52.3642 43.1279 51.5421L29.8051 41.8649C28.6746 41.0442 26.8246 41.0442 25.6954 41.8649L12.3727 51.5421C11.2421 52.3642 10.6707 51.949 11.1023 50.62L16.1919 34.9608C16.6222 33.6331 16.0507 31.8739 14.9216 31.0532L1.59745 21.3746C0.468261 20.5539 0.68615 19.8825 2.08393 19.8825H18.5503C19.9481 19.8825 21.4445 18.7946 21.8762 17.467L26.9657 1.80774Z",
    fill: "url(#paint_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear",
    x1: 0.874725,
    y1: 0.810974,
    x2: 0.874725,
    y2: 51.9645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarBanner);
export default __webpack_public_path__ + "static/media/icon-star-banner.cc92d6ac.svg";
export { ForwardRef as ReactComponent };